import React from 'react';
import { GBChips } from '@leapfinance/geebee-component-library';
import { isFalsy } from '../../../utils/common';
export var getSopPlagiarismChipVariant = function (score, conditionKey) {
    if (conditionKey === 'OVERALL_SCORE') {
        if (score > 0 && score <= 40) {
            return 'success';
        }
        if (score > 40 && score <= 60) {
            return 'warning';
        }
        return 'error';
    }
    if (conditionKey === 'SAME_UNIVERSITY_SCORE' || conditionKey === 'AI_CONTENT') {
        if (score > 0 && score <= 30) {
            return 'success';
        }
        if (score > 30 && score <= 50) {
            return 'warning';
        }
        return 'error';
    }
    if (conditionKey === 'WEB_PLAGIARISM_SCORE') {
        if (score > 0 && score <= 20) {
            return 'success';
        }
        if (score > 20 && score <= 35) {
            return 'warning';
        }
        return 'error';
    }
    return 'primary';
};
var SOPPlagiarismInfoChips = function (_a) {
    var _b, _c, _d, _e;
    var sopPlagiarismData = _a.sopPlagiarismData;
    if (isFalsy(sopPlagiarismData))
        return null;
    return (React.createElement("div", { className: "lfc-flex lfc-flex-wrap lfc-gap-3 lfc-w-full" },
        !isFalsy(sopPlagiarismData === null || sopPlagiarismData === void 0 ? void 0 : sopPlagiarismData.universityScore) ? (React.createElement(GBChips, { variant: getSopPlagiarismChipVariant(sopPlagiarismData === null || sopPlagiarismData === void 0 ? void 0 : sopPlagiarismData.universityScore, 'SAME_UNIVERSITY_SCORE'), title: "Plagiarism Score(Same University): ".concat((_b = sopPlagiarismData === null || sopPlagiarismData === void 0 ? void 0 : sopPlagiarismData.universityScore) !== null && _b !== void 0 ? _b : '--') })) : null,
        !isFalsy(sopPlagiarismData === null || sopPlagiarismData === void 0 ? void 0 : sopPlagiarismData.overallScore) ? (React.createElement(GBChips, { variant: getSopPlagiarismChipVariant(sopPlagiarismData === null || sopPlagiarismData === void 0 ? void 0 : sopPlagiarismData.overallScore, 'OVERALL_SCORE'), title: "Plagiarism Score(Overall): ".concat((_c = sopPlagiarismData === null || sopPlagiarismData === void 0 ? void 0 : sopPlagiarismData.overallScore) !== null && _c !== void 0 ? _c : '--') })) : null,
        !isFalsy(sopPlagiarismData === null || sopPlagiarismData === void 0 ? void 0 : sopPlagiarismData.webScore) ? (React.createElement(GBChips, { variant: getSopPlagiarismChipVariant(sopPlagiarismData === null || sopPlagiarismData === void 0 ? void 0 : sopPlagiarismData.webScore, 'WEB_PLAGIARISM_SCORE'), title: "Plagiarism Score(AI content): ".concat((_d = sopPlagiarismData === null || sopPlagiarismData === void 0 ? void 0 : sopPlagiarismData.webScore) !== null && _d !== void 0 ? _d : '--') })) : null,
        !isFalsy(sopPlagiarismData === null || sopPlagiarismData === void 0 ? void 0 : sopPlagiarismData.aiContentScore) ? (React.createElement(GBChips, { variant: getSopPlagiarismChipVariant(sopPlagiarismData === null || sopPlagiarismData === void 0 ? void 0 : sopPlagiarismData.aiContentScore, 'AI_CONTENT'), title: "AI content %age: ".concat((_e = sopPlagiarismData === null || sopPlagiarismData === void 0 ? void 0 : sopPlagiarismData.aiContentScore) !== null && _e !== void 0 ? _e : '--') })) : null));
};
export default SOPPlagiarismInfoChips;
//# sourceMappingURL=SOPPlagiarismInfoChips.js.map